import $ from "jquery";

$(document).ready(function(){

    if (typeof ga !== "function") {
        console.log('GA Events supppressed');
        return;
    }

    $('a[href^="http"], a[href^="//"]').click(function(e){
        let url = $(this).attr('href');
        ga('send', 'event', 'outbound', url, {useBeacon: true});
    });

    $('form').submit(function(e){
        let formName = $(this).attr('id');
        ga('send', 'event', 'submit', formName, {useBeacon: true});
    });

    $('input').focus(function(e){
        let inputName = $(this).attr('name');
        ga('send', 'event', 'input', inputName, {useBeacon: true});
    });

    $('img').click(function(e){
        let imageSrc = $(this).attr('src');
        ga('send', 'event', 'click', imageSrc, {useBeacon: true});
    });

});



// WEBPACK FOOTER //
// ./resources/js/ga-events.js